import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import "./../loader.css";

// Same recharts pattern PortalCharStats.js already uses (commented out
// there, but the library and approach were already chosen for this app
// -- this is the first LIVE use of it). Card/header classes copied from
// the same file's markup.
function UserUsageGraph() {
    const [myCases, setMyCases] = useState([]);
    const [selectedCase, setSelectedCase] = useState("");
    const [chartData, setChartData] = useState([]);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [loading, setLoading] = useState(false);

    const getToken = () => {
        try {
            const raw = localStorage.getItem("state");
            if (raw) {
                const state = JSON.parse(raw);
                return state.auth?.token;
            }
        } catch (e) {
            console.error("Token parsing failed", e);
        }
        return null;
    };

    useEffect(() => {
        const token = getToken();
        axios
            .get(`${process.env.REACT_APP_API_URL}/AppUser/GetMyCases`, {
                headers: { ...(token && { Authorization: `Bearer ${token}` }) },
            })
            .then((res) => {
                setMyCases(res.data || []);
                setIsInitialLoading(false);
            })
            .catch((err) => {
                console.error("Failed to load cases", err);
                setIsInitialLoading(false);
            });
    }, []);

    const fetchUsage = (patientId) => {
        if (!patientId) {
            setChartData([]);
            return;
        }
        setLoading(true);
        const token = getToken();
        axios
            .get(
                `${process.env.REACT_APP_API_URL}/AppUser/GetUsageHistory?patientId=${patientId}&days=30`,
                { headers: { ...(token && { Authorization: `Bearer ${token}` }) } }
            )
            .then((res) => {
                const parsed = (res.data || []).map((r) => ({
                    date: r.usage_Date,
                    charactersUsed: r.characters_Used,
                }));
                setChartData(parsed);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to load usage history", err);
                Swal.fire({
                    icon: "error",
                    title: "Failed",
                    text: "Could not load usage history.",
                    confirmButtonText: "Ok",
                });
                setLoading(false);
            });
    };

    const onCaseChange = (e) => {
        setSelectedCase(e.target.value);
        fetchUsage(e.target.value);
    };

    return (
        <div className="page-content-wrapper">
            {isInitialLoading ? (
                <div className="page-content d-flex justify-content-center align-items-center">
                    <div className="my-wrapper">
                        <div className="spinner center">
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                            <div className="spinner-blade"></div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className="pull-left">
                                <div className="page-title my-0">My Usage</div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-head">
                                    <header>
                                        <div className="row g-3 align-items-end">
                                            <div className="col-md-5">
                                                <label className="form-label">Select Case</label>
                                                <select
                                                    className="form-control"
                                                    value={selectedCase}
                                                    onChange={onCaseChange}
                                                >
                                                    <option value="">-- Choose Case --</option>
                                                    {myCases.map((c) => (
                                                        <option key={c.patient_Id} value={c.patient_Id}>
                                                            {c.case_Name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </header>
                                </div>
                                <div className="card-body">
                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : chartData.length > 0 ? (
                                        <ResponsiveContainer width="100%" height={400}>
                                            <BarChart data={chartData}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="date" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar
                                                    dataKey="charactersUsed"
                                                    name="Characters Used"
                                                    fill="#ffc63e"
                                                    radius={[4, 4, 0, 0]}
                                                />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    ) : (
                                        <div className="text-center py-5">
                                            <i className="fa fa-chart-line fa-3x" style={{ color: "#ccc" }} />
                                            <p className="mt-3" style={{ color: "#999" }}>
                                                {selectedCase
                                                    ? "No usage recorded yet for this case."
                                                    : "Select a case above to see your usage."}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UserUsageGraph;